export default __webpack_public_path__ + "static/media/smile1.f3015350.jpg";